<template>
    <div id="garantias">
        <encabezado></encabezado>
        <breadcrum :titulo="titulo" :texto="texto"></breadcrum>
        <div class="module module-info" style="padding-left: 20%; margin-top: 3%; width: 70%;">
            <!-- Texto Inicial -->
            <div class="form-row">
                <p class="text--s mb-4" style="font-family: Heebo;font-weight:normal">
                    Para comprobar si el servicio admite la reparación de su dispositivo en
                    garantía y fuera de ella y los costes estimados asociados a su recogida
                    y su envio, seleccione el fabricante y modelo de su dispositivo.<br />
                    <!-- <a class="enlace" @click="$router.go(-1)">Pulsando aquí, puede regresar a la página anterior</a>-->
                </p>
            </div>

            <!-- FABRICANTE -->
           
            <div class="form-row">
                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                        <v-autocomplete style="font-family: Heebo; font-weight: normal "
                                        v-model="fabricante" 
                                        :items="fabricantes" 
                                        item-value="IDFABRICANTE" 
                                        item-text="DESCRIPCION" size="60" type="text"

                                        placeholder="Fabricante * (teclee para autocompletar)" return-object></v-autocomplete>
               
                    </div>
                </div>

            </div>

         
            <!-- MODELO -->
            <div class="form-row"
                 v-if="fabricante != null && Object.keys(fabricante).length !== 0">
                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-40 elementor-field-required">
                        <v-autocomplete v-model="modelo"
                                        style="font-family: Heebo;  font-weight: normal "
                                        :items="modelosFiltrados"
                                        item-value="IDMODELO"
                                        item-text="DESCRIPCION" size="60" type="text"
                                        
                                        placeholder="Modelo del dispositivo * (teclee para autocompletar)"
                                        return-object></v-autocomplete>
                    </div>
                </div>
            </div>



            <div class="form-row"
                 v-if="modelo != null && Object.keys(modelo).length !== 0">
                <parrafo-garantias v-if="catalogosReparacion.length > 0" :catalogos-reparacion="catalogosReparacion"></parrafo-garantias>
                <card-garantia v-if="catalogosReparacion.length > 0"
                               :catalogos-reparacion="catalogosReparacion"
                               :precioEmbalaje="precioEmbalaje"
                               :calculoSinEmbalaje="true"></card-garantia>
            </div>

            <div v-if="$bus.esParticularSinRegistro" class="form-row mb-8">
                <p class="text--s" style="font-family: Heebo;font-weight:normal">
                    Puedes obtener las ventajas si te
                    <router-link to="/particularCR" class="link icon-green link--icon">
                        <span style="font-family: Heebo;font-weight:normal">suscribes al servicio</span>
                        <v-icon class="mt-n1" color="#9be51a">mdi-chevron-right</v-icon>
                    </router-link>
                </p>
                <p class="text--s mt-2" style="font-family: Heebo;font-weight:normal">Suscríbete al servicio por una cuota de 1,5€ al mes (IVA incluido) y no pagues el transporte ni la gestión de las reparaciones que solicites.</p>
            </div>
        </div>
                <pie></pie>
            </div>
</template>

<script>
export default {
  name: 'catalogo',
  components: {
    //encabezado: () => import("@/components/newEncabezado"),
    breadcrum: () => import("@/components/breadcrum"),
    parrafoGarantias: () => import("@/components/formulario/parrafoGarantias"),
    cardGarantia: () => import("@/components/formulario/cardGarantia"),
    tabla: () => import("@/components/Dinamicos/tabla"),
    //pie: () => import("@/components/newPie"),
      encabezado: () => import("@/components/newEncabezado"),
      pie: () => import("@/components/newPie"),
  },
  data: () => ({
    texto: "Aqui podrá revisar los dispositivos y sus garantías",
    titulo: "Catalogo",
    catalogos: [],
    catalogosReparacion: [],
    catalogo: {},
    fabricantes: [],
    fabricante: {},
    modelos: [],
    modelosFiltrados: [],
    modelo: {},
    precioEmbalaje: 0,
  }),
  created() {
    this.getCatalogo();
      this.getBasicData();
  },
  watch: {
    fabricante() {
      this.modelo = {};
      this.catalogo = {};
      this.modelosFiltrados =
        this.fabricante != undefined && this.fabricante != null
          ? this.modelos.filter(
              (x) => x.IDFABRICANTE == this.fabricante.IDFABRICANTE
            )
          : [];
    },
    modelo(val) {
      if (val != undefined && val != null) {
        if (val.IDMODELO != null && val.IDMODELO != undefined &&
            val.ID_TIPO_MODELO != null && val.ID_TIPO_MODELO != undefined &&
            this.fabricante.IDFABRICANTE != null && this.fabricante.IDFABRICANTE != undefined) {
          this.catalogosReparacion = [];
          this.getIdTallerMapeo(this.modelo.ID_TIPO_MODELO, this.fabricante.IDFABRICANTE, this.modelo.IDMODELO);
        }else{
          this.catalogosReparacion = [];
        }
      }else{
        this.catalogosReparacion = [];
      }
    },
  },
  methods: {
    getBasicData() {
      let json = { keys: ["Manufactures", "Modelos"] };
      this.$API.getBasicData(json).then((response) => {
        if (response != "") {
          this.fabricantes = response.Manufactures;
          this.modelos = response.Models;
        }
      });
    },

    /**
     * OBTNER LOS CATALOGOS DE BACKEND
     * @description Llamada a la API para obtener todos los catalogos (MODELOS_TALLER)
     */
    getCatalogo() {
      this.$API.getCatalogo().then((response) => {
        if (response != "" && response.catalogos.length > 0)
          this.catalogos = response.catalogos;
        else this.catalogos = [];
      });
    },

    /**
     * OBTENER EL IDTALLER DEL MAPEO
     * @description Llamada a la API para obtener el identificador del taller que tiene asignada la reparación de dicho modelo
     * Con este identificador obtenemos posteriormente los catalogos (MODELOS_TALLER) que reparan dicho dispositivo en garantía o fuera de garantía.
     * @param {Number} idTipoModelo identificador tipo de modelo del modelo seleccionado
     * @param {Number} idFabricante identificador del fabricante del modelo seleccionado
     * @param {Number} idModelo identificador del modelo seleccionado
     * @property {Object} data request para el servidor, enviando los parametros necesarios para la solicitud del recurso
     */
    getIdTallerMapeo(idTipoModelo, idFabricante, idModelo) {
      let data = {};
      data['idTipoModelo'] = idTipoModelo
      data['idFabricante'] = idFabricante
      data['idModelo'] = idModelo

      this.$API.getIdTallerMapeo(data).then((response) => {
        if (response != "") {
          console.log('idTaller --> ' + response.idTaller);
          this.comprobarCatalogo(response.idTaller)
        } else { this.catalogosReparacion = []; }
      });
    },

    /**
     * MÉTODO QUE COMPRUEBA SI HAY UN CATALOGO DE REPARACION PARA UN TALLER
     * @description Llamada a la API para obtener los catalogos (MODELOS_TALLER) que corresponden a un taller, un modelo, un fabricante y/o un tipo de modelo.
     * Catalogos (MODELOS_TALLER) que reparan dicho dispositivo en garantía o fuera de garantía.
     * El método busca de forma jerarquica, de más específico (modelo, fabricante, tipoDeModelo) a menos (tipoDeModelo), teniendo en cuenta que busca por taller en
     * todas las ocasiones. Si no encuentra en un nivel específico pasa a buscar en un nivel menos específico.
     */
    comprobarCatalogo(idTaller) {
      // debugger
      if (idTaller != null && idTaller != undefined) {

          // Primero buscamos si coincide el modelo exacto
          if (this.modelo != undefined && this.modelo != null) {
            this.catalogosReparacion = this.catalogos.filter(
              (s) =>
                s.IDMODELO == this.modelo.IDMODELO &&
                s.IDTALLER == idTaller
            )
            console.log('');
          }

          // Si no coincide, buscamos por tipo de modelo y fabricante
          if (this.catalogosReparacion.length == 0 && this.fabricante != undefined && this.fabricante != null && this.modelo != undefined && this.modelo != null) {
            this.catalogosReparacion = this.catalogos.filter(
              (s) =>
                s.ID_TIPO_MODELO == this.modelo.ID_TIPO_MODELO &&
                s.IDFABRICANTE == this.fabricante.IDFABRICANTE &&
                s.IDMODELO == null &&
                s.IDTALLER == idTaller
            )
          }

          // Si no coincide, buscamos por tipo de modelo
          if (this.catalogosReparacion.length == 0 && this.modelo != undefined && this.modelo != null) {
            this.catalogosReparacion = this.catalogos.filter(
              (s) =>
                s.ID_TIPO_MODELO == this.modelo.ID_TIPO_MODELO &&
                s.IDFABRICANTE == null &&
                s.IDMODELO == null &&
                s.IDTALLER == idTaller
            )
          }
        }
    }

  },
};
</script>

<style>

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }

   
    ::placeholder {
        font-family: Heebo;
        color: #606060;
        font-weight: normal
    }


     .v-input__append-inner {
        border-bottom: 1px solid #D3D3D3;
    }

    .v-autocomplete {
        border: 0px solid white !important;
        min-width: 650px !important;
    }

    .v-input__slot::after {
        border: 1px solid #9be51a !important;
    }
 
    .v-input__slot::before
    {
        display: none;
    }



    /*
.module.module_services .items_list .item {
  width: calc(var(--grid_columns_size) * 3.5 - 0.1px) !important;
}

#garantias .text-start {
  font-weight: bold;
  text-align: left;
}

#garantias .centrar-contenido {
  justify-content: center;
}

#garantias .v-input button {
  background-color: transparent;
}


    
#garantias #autoTipo,
#garantias #autoModelo,
#garantias #autoSintoma,
#garantias .v-input--checkbox .v-input__slot {
  border: 0px solid white !important;
}

*/

</style>